import { TokenService } from '../services/storage.service';
import { cloneArray } from '../utility/routines';
import DocumentService from '../services/document.service';

// initial state
const state = {
    allMenuItems: [], // исходые пункты меню (всё меню)
    menuItems: [], // актуальное меню с учётом статуса авторизации и доступа
    menuItemsCount: [] // значения кол-во для пункта меню
};

// getters
const getters = {};

// actions
const actions = {
    async initMenuItems({ commit, dispatch }, menuItems) {
        await dispatch('getMenuItemCount');
        commit('setAllMenuItems', menuItems);
        commit('setMenuItems', menuItems);
    },
    async reloadMenuItems({ commit, dispatch, state }) {
        await dispatch('getMenuItemCount', state.userId);
        commit('setMenuItems', state.allMenuItems);
    },
    async getMenuItemCount({ commit, rootGetters }) {
        let userId = rootGetters['user/userId'];
        if (userId) {
            let docCountData = await DocumentService.getGrouppedDocCounts(userId);
            commit('setMenuItemsCount', docCountData);
        }
    }
};

// mutations
const mutations = {
    setAllMenuItems(state, value) {
        state.allMenuItems = value;
    },
    setMenuItems(state, value) {
        let loggedIn = !!TokenService.getToken();
        // console.log('logged: ' + loggedIn);
        // фильтрация видимости
        let tmpMenuItems = value.filter(item => {
            if (item.meta.public && !loggedIn) {
                // console.log('Публичные для неавторизованных: ' + item.meta.title);
                return true;
            } else if (item.meta.public && loggedIn && !item.meta.onlyWhenLoggedOut) {
                // console.log('Публичные для авторизованных: ' + item.meta.title);
                return true;
            } else if (!item.meta.public && loggedIn && !item.meta.onlyWhenLoggedOut) {
                // console.log('Закрыты для авторизованных: ' + item.meta.title);
                return true;
            }
        });
        // кланируем массив через JSON-серилизацию, чтоб сделалились именно копии объектов
        // иначе 2 разных массива будут хранить в себе ссылки на одни и те же объекты
        // в результате каждое перестроение меню будет наращивать пункты меню
        tmpMenuItems = cloneArray(tmpMenuItems);

        // группировка вложенных меню
        let groupedMenuItems = [];
        let menuItemsNamesArray;
        if (state.menuItemsCount) {
            menuItemsNamesArray = state.menuItemsCount.map(function(e) {
                return e.name;
            });
        }
        for (let i = 0; i < tmpMenuItems.length; i++) {
            // для пунктов меню, где в метаинформации задан статус
            // добавляем данные о кол-ве едениц для пункта меню
            if (menuItemsNamesArray && tmpMenuItems[i].meta && tmpMenuItems[i].meta.statusName) {
                let itemWithCount = state.menuItemsCount[menuItemsNamesArray.indexOf(tmpMenuItems[i].meta.statusName)];
                if (itemWithCount) {
                    tmpMenuItems[i].meta.valueCount = itemWithCount.count;
                } else {
                    tmpMenuItems[i].meta.valueCount = 0;
                }
            }

            if (tmpMenuItems[i].meta.parentItemName) {
                let pos = groupedMenuItems
                    .map(function(e) {
                        return e.name;
                    })
                    .indexOf(tmpMenuItems[i].meta.parentItemName);
                if (!groupedMenuItems[pos].items) {
                    groupedMenuItems[pos].items = [];
                }
                groupedMenuItems[pos].items.push(tmpMenuItems[i]);
            } else {
                groupedMenuItems.push(tmpMenuItems[i]);
            }
        }
        state.menuItems = groupedMenuItems;
    },

    setMenuItemsCount(state, value) {
        state.menuItemsCount = value;
    },
    setUserId(state, value) {
        state.userId = value;
    }
};

export const toolbar = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
